import { Controller } from "@hotwired/stimulus"

// Przełącznik pionów na formularzu dodawania leada.
// Pokazuje burBlock lub insuranceBlock zależnie od wartości verticalSelect.
// Wywoływany przy podłączeniu (honoring initial select value) i przy zdarzeniu change.
export default class extends Controller {
  static targets = ["verticalSelect", "burBlock", "insuranceBlock"]

  connect() {
    this.switch()
  }

  switch() {
    const value = this.verticalSelectTarget.value
    this.burBlockTarget.hidden = value !== "bur"
    this.insuranceBlockTarget.hidden = value !== "ubezpieczenia"
  }
}
